export function initMobileMenu() {
    for (const toggle of document.getElementsByClassName('mobile-menu-toggle')) {
        toggle.addEventListener('click', function () {
            document.body.classList.toggle('show-menu');
        });
    }

    if (window.screen.width <= 991) {
        for (const child of document.querySelectorAll('.has-children')) {
            child.addEventListener('click', function (e) {
                if (e.target.classList.contains('arrow')) {
                    e.preventDefault();
                    child.classList.toggle('open');
                }
            });
        }
    }
}

export function initStickyMenu() {
    const mainNav = document.querySelector(".main-navbar");
    const topNav = document.querySelector(".top-navbar");
    const toggleClass = "is-sticky";

    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > 150) {
            mainNav.classList.add(toggleClass);
            topNav.classList.add(toggleClass);
        } else {
            mainNav.classList.remove(toggleClass);
            topNav.classList.remove(toggleClass);
        }
    });
}
